import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Initialize GA4 only once
        const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
        if (measurementId) {
            if (!window.gaInitialized) {
                ReactGA.initialize(measurementId);
                window.gaInitialized = true;
            }

            // Send pageview with a custom path
            ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
        }
    }, [location]);

    return null;
};

export default AnalyticsTracker;
